import { FunctionComponent } from "react";
import { academyVideoCategory } from "../../../../../utils/enums";
import VideoLayout from "../components/VideosLayout";

interface LifeProps {}

const Life: FunctionComponent<LifeProps> = () => {
  const segment = academyVideoCategory.Life_at_kazam;

  return <VideoLayout segment={segment} />;
};

export default Life;
